import { tokens } from '@news-mono/design-tokens'
import { calcRem } from '../../__styling'

//setup is all based on PN design system for Buttons
//https://www.figma.com/design/aVn9HftV7eysVaVGVROiWv/PerthNow-Design-System-2.0?node-id=31-5369&m=dev

/**
 * primary: filled button, secondary: outline button, tertiary: text button
 */
export type PNButtonType = 'primary' | 'secondary' | 'tertiary'
export type PNButtonSize = 'S' | 'M' | 'L'
export type PNButtonState = 'default' | 'hover' | 'focus'

export type PNButtonBorder = { width: string; color: string; style: string }

/**
 * Creates a color with a black overlay
 * @param opacity specify an opacity lvl between 0 and 1
 * @param color the colour you want under the black overlay
 * @returns a uniform color with the overlay imposed as a linear-gradient
 */
const blackOverlay = (opacity: number, color: string) =>
    `linear-gradient(0deg, rgba(0, 0, 0, ${opacity}) 0%, rgba(0, 0, 0, ${opacity}) 100%), ${color}`

interface PNButtonStylesType {
    size: Record<
        PNButtonSize,
        {
            padding: string
            fontSize: string
            height: string
            borderRadius: string
        }
    >
    colors: Record<
        PNButtonType,
        Record<
            PNButtonState,
            {
                background: string
                color: string
                borderWidth?: string
                borderStyle?: 'dotted' | 'solid' | 'double' | 'dashed'
                borderColor?: string
            }
        >
    >
}

const { pinkThulite, white, black } = tokens.perthnow.colors.palette

export const PNButtonStyles: PNButtonStylesType = {
    size: {
        S: {
            padding: calcRem(8, 12),
            fontSize: calcRem(14),
            height: calcRem(32),
            borderRadius: calcRem(8),
        },
        M: {
            padding: calcRem(8, 24),
            fontSize: calcRem(16),
            height: calcRem(48),
            borderRadius: calcRem(8),
        },
        L: {
            padding: calcRem(8, 24),
            fontSize: calcRem(16),
            height: calcRem(56),
            borderRadius: calcRem(12),
        },
    },
    colors: {
        primary: {
            default: {
                color: white,
                background: pinkThulite,
            },
            hover: {
                background: blackOverlay(0.04, pinkThulite),
                color: white,
            },
            focus: {
                background: blackOverlay(0.1, pinkThulite),
                color: white,
            },
        },
        secondary: {
            default: {
                background: white,
                color: pinkThulite,
                borderColor: pinkThulite,
                borderStyle: 'solid',
                borderWidth: calcRem(1),
            },
            hover: {
                background: blackOverlay(0.04, white),
                color: pinkThulite,
                borderColor: pinkThulite,
                borderStyle: 'solid',
                borderWidth: calcRem(1),
            },
            focus: {
                background: blackOverlay(0.1, white),
                color: pinkThulite,
                borderColor: pinkThulite,
                borderStyle: 'solid',
                borderWidth: calcRem(1),
            },
        },
        tertiary: {
            default: {
                background: white,
                color: black,
            },
            hover: {
                background: blackOverlay(0.04, white),
                color: black,
            },
            focus: {
                background: blackOverlay(0.1, white),
                color: black,
            },
        },
    },
}
